import { DAPI_HOST } from '../../config';

const getPaperworkResponsesUrl = () => `${DAPI_HOST}/v1/paperwork-responses`;

const getPaperworkDataUrl = bookingId =>
  `${DAPI_HOST}/v2/paperwork-responses?booking_id=${bookingId}&type_=registration`;

export { getPaperworkResponsesUrl, getPaperworkDataUrl };
